import Router from "vue-router";
import Vue from "vue";

Vue.use(Router);

const router = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    scrollBehavior(to, from, savedPosition) {
        return savedPosition || { x: 0, y: 0 };
    },
    routes: [
        {
            path: "/",
            component: () => import("@/pages/index/IndexLayout.vue"),
            children: [
                {
                    beforeEnter: () => location.href = 'https://joinladder.com',
                    path: "",
                    name: "IndexLanding",
                    component: () =>
                        import("@/pages/index/IndexLandingView.vue")
                },
                {
                    beforeEnter: () => location.href = 'https://joinladder.com/clubs',
                    path: "club",
                    name: "IndexClub",
                    meta: {
                        title: "Club"
                    },
                    component: () => import("@/pages/index/IndexClubView.vue")
                },
                {
                    beforeEnter: () => location.href = 'https://joinladder.com/coaches',
                    path: "coach",
                    name: "IndexCoach",
                    meta: {
                        title: "Coach"
                    },
                    component: () => import("@/pages/index/IndexCoachView.vue")
                },
                {
                    beforeEnter: () => location.href = 'https://joinladder.com/contact',
                    path: "contact",
                    name: "IndexContact",
                    meta: {
                        title: "Contact"
                    },
                    props: true,
                    component: () =>
                        import("@/pages/index/IndexContactView.vue")
                },
                {
                    path: "auth/reset",
                    name: "IndexReset",
                    meta: {
                        title: "Reset Password"
                    },
                    props: true,
                    component: () => import("@/pages/index/IndexResetView.vue"),
                    children: [
                        {
                            path: ":token",
                            props: true
                        },
                        {
                            path: ":token/:email",
                            props: true
                        }
                    ]
                }
            ]
        },
        {
            path: "/legal",
            redirect: "/terms",
            component: () => import("@/pages/legal/LegalLayout.vue"),
            children: [
                {
                    beforeEnter: () => location.href = 'https://joinladder.com/terms',
                    path: "/terms",
                    name: "terms",
                    meta: {
                        title: "Terms of Service"
                    },
                    component: () => import("@/pages/legal/LegalTermsView.vue")
                },
                {
                    beforeEnter: () => location.href = 'https://joinladder.com/privacy',
                    path: "/privacy",
                    name: "privacy",
                    meta: {
                        title: "Privacy Policy"
                    },
                    component: () =>
                        import("@/pages/legal/LegalPrivacyView.vue")
                }
            ]
        },
        {
            path: "/checkout",
            props: true,
            component: () => import("@/pages/checkout/CheckoutLayout.vue"),
            children: [
                {
                    path: "",
                    name: "Checkout",
                    meta: {
                        title: "Checkout"
                    },
                    component: () =>
                        import("@/pages/checkout/CheckoutCartView.vue")
                },
                {
                    path: "success",
                    name: "CheckoutSuccess",
                    meta: {
                        title: "Checkout Complete"
                    },
                    component: () =>
                        import("@/pages/checkout/CheckoutSuccessView.vue")
                }
            ]
        },
        {
            path: "/invite",
            alias: ["/i", "/coach-direct-invitation", "/offer"],
            props: true,
            component: () => import("@/pages/invite/InviteLayout.vue"),
            children: [
                {
                    // Everything else handled as an offer token
                    // Also aliasing to handle old "invites"
                    path: ":token",
                    name: "InviteLanding",
                    meta: {
                        title: "Coach Invite"
                    },
                    component: () =>
                        import("@/pages/invite/InviteLandingView.vue")
                }
            ]
        },
        {
            path: "/:username",
            props: true,
            component: () =>
                import("@/pages/attribution/AttributionLayout.vue"),
            children: [
                {
                    path: "",
                    name: "CoachPage",
                    props: true,
                    component: () => import("@/pages/coach/CoachIndexView.vue")
                },
                {
                    path: "contact",
                    name: "CoachPageContact",
                    meta: {
                        title: "Contact"
                    },
                    props: true,
                    component: () =>
                        import("@/pages/coach/CoachContactView.vue")
                }
            ]
        }
    ]
});

// Update the page title (based on the meta title of the route) before each route loads
router.beforeEach((to, from, next) => {
    document.title = to.meta.title
        ? "Ladder" + " - " + to.meta.title
        : "Ladder";
    next();
});

export default router;
